module.exports = [{"id":1,"name":"Türkçe","code":"tr"},{"id":2,"name":"English","code":"en"},{"id":3,"name":"Português","code":"pt"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/langs.json
// module id = zidE
// module chunks = 1